import RichText from '@/components/ui/RichText/RichText';
import { WhatIsYourConcern } from '@/types/richTextTypes';

type Props = {
  data: Pick<WhatIsYourConcern, 'heading' | 'description'>;
};

const CarouselIntro = ({ data }: Props) => {
  return (
    <div className="bg-surface-brand-strong flex w-[70%] flex-col justify-start rounded-r-2xl p-6 py-10 text-white md:w-full md:py-14">
      {data?.heading?.content ? (
        <RichText styles={data.heading.styles} className="">
          {data.heading.content}
        </RichText>
      ) : null}

      {data?.description?.content ? (
        <RichText styles={data.description.styles} className="">
          {data.description.content}
        </RichText>
      ) : null}
    </div>
  );
};

export default CarouselIntro;
